export const NAV_LINKS = [
  { label: "Work", path: "/work" },
  { label: "Services", path: "/services" },
  { label: "Studio", path: "/studio" },
  { label: "Philosophy", path: "/philosophy" },
  { label: "Case Studies", path: "/case-studies" },
  { label: "Blog", path: "/blog" },
  { label: "About", path: "/about" },
];

export const CONTACT = {
  address: "29, P.C Ghosh Road, Nirmala Gold, Second Floor, Kolkata 700048",
  email: "reachus@nexastudioindia.com",
  phone: "98313 66263",
  phoneRaw: "+919831366263",
  phone2: "85829 96823",
  phone2Raw: "+918582996823",
  site: "nexastudioindia.com",
};

export const SERVICES = [
  {
    id: "brand-building",
    num: "01",
    title: "Brand Building",
    seoTitle: "Brand Building Agency in Kolkata",
    line: "Strategy, identity, positioning. We build brands with a spine — then we teach them to snarl.",
    para: "Strategy, positioning, naming, identity and guidelines, built by one in house team. We build brands with a spine, then teach them to snarl. Twelve years and 100+ brands across sports, FMCG, real estate and beverages.",
    links: [{ label: "Brand building services in Kolkata", to: "/blog/brand-building-services-kolkata" }],
    points: ["Brand strategy & positioning", "Naming & verbal identity", "Visual identity systems", "Launch & relaunch programmes"],
  },
  {
    id: "social-media",
    num: "02",
    title: "Social Media Management",
    seoTitle: "Social Media Management in Kolkata",
    line: "Daily warfare for attention. Calendars, communities and campaigns that refuse to scroll blend.",
    para: "Calendars, communities and campaigns that refuse to blend into the scroll. Content concepted, produced and posted by the same team that built the brand voice. Reported in leads and sales, not just likes.",
    points: ["Channel strategy & calendars", "Community management", "Creator & influencer programmes", "Always on content ops"],
  },
  {
    id: "performance",
    num: "03",
    title: "Performance Marketing",
    seoTitle: "Performance Marketing Agency in Kolkata",
    line: "Every rupee audited. We buy outcomes — leads, sales, market share — not impressions.",
    para: "Paid social and search, funnels, landing pages and constant testing. Every rupee is audited against outcomes: leads, sales, market share.",
    links: [{ label: "Performance marketing agency in Kolkata", to: "/blog/performance-marketing-agency-kolkata" }],
    points: ["Paid search & social", "Funnel & CRO programmes", "Attribution & reporting", "Retention & remarketing"],
  },
  {
    id: "content",
    num: "04",
    title: "Content Creation",
    seoTitle: "Content Creation Agency in Kolkata",
    line: "Scroll stopping content systems, concepted and produced in house. Volume without the vacancy.",
    para: "Scroll stopping content systems, concepted and produced in house. One shoot, many assets: reels, stills, cut-downs and long form from a single day on the floor.",
    points: ["Content systems & formats", "Copy & scriptwriting", "Reels, shorts & motion", "Editorial & campaign content"],
  },
  {
    id: "podcasts",
    num: "05",
    title: "Podcasts",
    seoTitle: "Podcast Production in Kolkata",
    line: "Long form voice in a short form world. Branded podcasts and Nexa Originals, end to end.",
    para: "Branded podcasts and Nexa Originals, end to end: format, scripting, recording, editing, distribution and promotion.",
    links: [{ label: "Podcast production in Kolkata", to: "/blog/podcast-production-kolkata" }],
    points: ["Show concept & format", "Recording & production", "Distribution & clips engine", "Host & guest management"],
  },
  {
    id: "shoots",
    num: "06",
    title: "Shoots",
    seoTitle: "Ad Film Makers in Kolkata",
    line: "Ad films, product films, photography. Our own floor, our own crew, our own obsession with the frame.",
    para: "Ad films, product films, corporate films and photography. Our own floor, our own crew, our own obsession with the frame.",
    links: [{ label: "Ad film makers in Kolkata", to: "/blog/ad-film-makers-kolkata" }],
    points: ["TVCs & ad films", "Corporate & brand films", "Product & food photography", "BTS & documentary coverage"],
  },
  {
    id: "design",
    num: "07",
    title: "Design Services",
    seoTitle: "Design, Logo and Website Development in Kolkata",
    line: "Packaging, digital, environments. Design that earns its place on the shelf and the screen.",
    para: "Logo design and brand identity, packaging, digital and environments, plus websites built to rank and convert. Design that earns its place on the shelf and the screen.",
    links: [
      { label: "Logo design company in Kolkata", to: "/blog/logo-design-company-kolkata" },
      { label: "Website development company in Kolkata", to: "/blog/website-development-company-kolkata" },
    ],
    points: ["Packaging design", "Campaign & key visual design", "UI/UX & web design", "Spatial & retail design"],
  },
];

export const MANIFESTO = [
  {
    num: "01",
    title: "Attention is the only currency.",
    body: "Every brief, every frame, every rupee is spent in the attention market. If the work doesn't stop a thumb, a walk, a conversation — it is expenditure, not investment. We price our thinking in seconds earned, not deliverables shipped.",
  },
  {
    num: "02",
    title: "Safe is the most expensive strategy.",
    body: "Safe work is invisible work, and invisible work costs you the entire budget plus the opportunity. The brands that win are not the loudest — they are the clearest about what they refuse to be. We would rather be argued about than ignored.",
  },
  {
    num: "03",
    title: "Brands are built in public.",
    body: "A brand is not a PDF. It is a daily performance — in feeds, in streets, on shelves, in group chats. We run brands like newsrooms: publishing, reacting, provoking, every single day. Consistency is not repetition; it is a drumbeat.",
  },
  {
    num: "04",
    title: "Performance is proof.",
    body: "Creativity that cannot be measured is a hobby. Every campaign we ship carries a hypothesis and a number attached to it. We report in outcomes — leads, sales, share — and we treat the dashboard as a creative tool, not an autopsy.",
  },
  {
    num: "05",
    title: "Content never clocks out.",
    body: "Your customer scrolls at midnight. Your brand should be awake. We build content systems — films, podcasts, posts, packaging — that keep selling long after the campaign ends. One shoot, thirty assets, ninety days of ammunition.",
  },
  {
    num: "06",
    title: "Craft is the last unfair advantage.",
    body: "Anyone can buy reach. Nobody can buy taste. The kerning, the cut, the colour grade, the pause before the punchline — craft is what makes attention convert into affection. We sweat details most people never notice, because everyone feels them.",
  },
];

export const TONALITY = {
  principles: [
    { title: "Loud visuals, measured words.", body: "The design roars so the copy doesn't have to. We state; we never shout. No exclamation marks doing the work of weak ideas." },
    { title: "Direct over clever.", body: "If a line needs explaining, it gets cut. We write like we talk across a table — short sentences, active verbs, zero jargon." },
    { title: "Confident, never arrogant.", body: "We make claims we can prove and we show the proof. Aggression is aimed at the work, never at the audience." },
    { title: "Culturally current.", body: "We speak the language of the feed without begging for its approval. References expire; insight doesn't." },
  ],
  say: ["We build brands with a spine.", "Attention, then affection, then revenue.", "Here's the number. Here's how we'll move it.", "No."],
  neverSay: ["Synergy. Solutions. Delight. Leverage.", "Going viral (as a plan).", "Trust us.", "Whatever you say, boss."],
};

export const INVOCATION = {
  kicker: "00 — The invocation",
  title: "Kshetrapala Bhairava.",
  sub: "The sentinel of the field.",
  body: "In the old temples of the east, Kshetrapala Bhairava stands at the boundary of the sacred field: the fierce guardian who never sleeps, who lets nothing uninvited cross the line he has sworn to hold. Every brand owns a kshetra. A market. A feed. A place in people's minds. Nexa Studio takes that post for your brand. Not loud for the sake of noise, vigilant for the sake of the territory. We guard the field, we strike at what threatens it, and we do not clock out.",
};

export const TIMELINE = [
  { year: "2013", event: "Myndroot opens its doors in Kolkata — a small room, a large chip on its shoulder." },
  { year: "2017", event: "Campaign communication for the FIFA U-17 World Cup. The world stage stops being theoretical." },
  { year: "2019", event: "IPL, TATA Steel Chess, OPPO — national brands join the roster." },
  { year: "2022", event: "Full production capability in house: films, photography, packaging, performance under one roof." },
  { year: "2024", event: "100+ brand engagements across FMCG, beverages, real estate, events and enterprise." },
  { year: "2026", event: "Nexa Studio launches. The second act — same scars, sharper teeth." },
];

export const FOUNDERS = [
  {
    initials: "IM",
    name: "Indira Mukherjee",
    role: "Co Founder — Strategy & Brand Direction",
    bio: "Twelve years of positioning brands that outlast their campaigns. Indira runs the room where briefs are interrogated, markets are read, and a brand's spine is decided before a single pixel moves.",
    img: "/brand/founder-indira.jpg",
    pos: "object-top",
  },
  {
    initials: "AB",
    name: "Ankit Bhattacharyya",
    role: "Co Founder — Creative & Production",
    bio: "From packaging floors to film sets, Ankit has spent twelve years turning strategy into things people can see, hear and hold. He runs the studio's craft: design, content, podcasts and the shoot floor.",
    img: "/brand/founder-ankit.jpg",
    pos: "object-top",
  },
];

export const CASE_STUDIES = [
  {
    num: "01",
    client: "Vairagi Beer",
    sector: "Beverages",
    year: "2026",
    title: "A monk walks into a bar.",
    challenge: "India's craft beer shelf is crowded with loud labels saying nothing. Vairagi needed a brand world that could carry an unusual name — the ascetic — into the most hedonistic aisle in the store, without turning it into a joke or a lecture.",
    approach: "We leaned into the tension instead of resolving it. The brand world was built on controlled contradiction: monastic restraint on the surface, sensory indulgence underneath. Identity, packaging and launch content were designed as one system, so the bottle, the feed and the bar told the same story.",
    outcome: "A label people photograph before they drink. The launch carved out instant shelf recognition in a category where newcomers are usually invisible, and gave the brand a story bartenders could retell.",
    deliverables: ["Brand identity & packaging", "Launch campaign", "Social media system", "Photography & film"],
    img: "/work/27904.jpg",
  },
  {
    num: "02",
    client: "Jewelbox",
    sector: "Jewellery",
    year: "2024",
    title: "Making heirlooms speak to the feed generation.",
    challenge: "Jewellery in India is bought on trust built over generations. Jewelbox had the craft but not the conversation: younger buyers scroll past traditional jewellery advertising because it looks like their mother's newspaper.",
    approach: "We rebuilt the brand's presence around intimacy instead of grandeur. Close crop photography, real skin, real light, copy that talks about moments rather than carats. The identity was tightened to let the product breathe, and campaigns were built as ongoing editorial rather than seasonal bursts.",
    outcome: "A jewellery house that behaves like a modern editorial brand. Engagement stopped depending on festive spikes, and the brand earned a year round voice with the buyers it was built for next.",
    deliverables: ["Brand identity refresh", "Campaign platform", "Editorial photography", "Content system"],
    img: null,
  },
  {
    num: "03",
    client: "FIFA U-17 World Cup 2017",
    sector: "Events",
    year: "2017",
    title: "The world came to Kolkata. Kolkata had to look the part.",
    challenge: "India's first FIFA tournament was not just a sporting event, it was a statement. Host city communication had to move a cricket obsessed city to fill football stadiums, across languages, demographics and attention spans, on a fixed deadline with zero room for drift.",
    approach: "Campaign communication designed for the street first. High visibility outdoor, transit and public touchpoints backed by regional language messaging that made the tournament feel owned by the city rather than visiting it. Every asset was built to be read at speed.",
    outcome: "The tournament drew record crowds for its tier and Kolkata's matches ran at capacity. The campaign became part of the city's visual memory of 2017, proof that the team could carry a world stage brief.",
    deliverables: ["Campaign communication", "Outdoor & transit media", "Regional language adaptations", "Event collateral"],
    img: null,
  },
];

export const IMAGES = {
  podcast: "/brand/studio-shoot-thumb.jpg",
  shoot: "/brand/studio-shoot-bts.jpg",
  founder: "https://images.pexels.com/photos/4687575/pexels-photo-4687575.jpeg?auto=compress&cs=tinysrgb&w=1200",
  team: "/brand/studio-shoot-floor.jpg",
};
